/* eslint-disable react-hooks/exhaustive-deps */
import useContactos from "features/Contactos/hooks/useContactos"
import { userSelector } from "features/User/redux/slices/userSlice"
import { useSelector } from "hooks/useSelector"
import { useEffect } from "react"
// @ts-expect-error TS(7016): Could not find a declaration file for module 'reac...
import TagManager from "react-gtm-module"
import { Route, useHistory, useLocation } from "react-router-dom"

const tagManagerArgs = {
  gtmId: "GTM-T8X7T37",
}
import.meta.env.MODE !== "development" && TagManager.initialize(tagManagerArgs)

const PrivateRoute = (props: $TSMigrationFixMe) => {
  const location = useLocation()
  const { identityId } = useSelector(userSelector)
  // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
  const { setContactosFilters } = useContactos()
  const history = useHistory()

  useEffect(() => {
    localStorage.setItem("prePath", location.pathname)
  }, [])

  const restoreFilters = (path: $TSMigrationFixMe) => {
    const prePathName = localStorage.getItem("prePath")
    localStorage.setItem("prePath", path)
    if (
      !(prePathName?.includes("/contactos") && path?.includes("/contactos"))
    ) {
      setContactosFilters({})
    }
  }

  useEffect(() => {
    const unlisten = history.listen((location: $TSMigrationFixMe) => {
      restoreFilters(location.pathname)
      // @ts-expect-error TS(2339): Property 'dataLayer' does not exist on type 'Windo...
      window?.dataLayer?.push({
        id_usuario: identityId,
      })
    })
    return function cleanup() {
      unlisten()
    }
  }, [])

  return (
    <Route
      exact
      {...props}
    />
  )
}

export default PrivateRoute
